import React from 'react';

const SeccionesContext = React.createContext();
export default SeccionesContext;
